import React, { useMemo } from 'react';

function esc(value) {
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function inlineFormat(value) {
  return String(value)
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/`(.+?)`/g, '<code>$1</code>')
    .replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank" rel="noreferrer">$1</a>');
}

function renderMarkdown(md) {
  let html = md
    .replace(/```(\w*)\n([\s\S]*?)```/g, (_, lang, code) => `<pre class="hc-doc-code"><code class="lang-${lang || 'text'}">${esc(code.trim())}</code></pre>`)
    .replace(/^\|(.+)\|\s*\n\|\s*[-:]+[-| :]*\|\s*\n((?:\|.+\|\s*\n?)*)/gm, (_, header, body) => {
      const ths = header
        .split('|')
        .map((c) => c.trim())
        .filter(Boolean)
        .map((c) => `<th>${c}</th>`)
        .join('');

      const rows = body
        .trim()
        .split('\n')
        .map((row) => {
          const tds = row
            .split('|')
            .map((c) => c.trim())
            .filter(Boolean)
            .map((c) => `<td>${inlineFormat(c)}</td>`)
            .join('');
          return `<tr>${tds}</tr>`;
        })
        .join('');

      return `<div class="hc-doc-table-wrap"><table><thead><tr>${ths}</tr></thead><tbody>${rows}</tbody></table></div>`;
    })
    .replace(/^### (.+)$/gm, '<h3>$1</h3>')
    .replace(/^## (.+)$/gm, '<h2>$1</h2>')
    .replace(/^- (.+)$/gm, '<li>$1</li>')
    .replace(/(<li>[\s\S]*?<\/li>)/g, (match) => (match.includes('<ul>') ? match : `<ul>${match}</ul>`))
    .replace(/^\d+\. (.+)$/gm, '<oli>$1</oli>')
    .replace(/(<oli>[\s\S]*?<\/oli>)/g, (match) => {
      const inner = match.replace(/<\/?oli>/g, (token) => (token === '<oli>' ? '<li>' : '</li>'));
      return `<ol>${inner}</ol>`;
    })
    .replace(/\n{2,}/g, '\n\n')
    .split('\n\n')
    .map((block) => {
      const text = block.trim();
      if (!text) return '';
      if (text.startsWith('<')) return text;
      return `<p>${inlineFormat(text)}</p>`;
    })
    .join('\n');

  html = html.replace(/<\/ul>\s*<ul>/g, '');
  html = html.replace(/<\/ol>\s*<ol>/g, '');

  return html;
}

export function DocRenderer({ content }) {
  const html = useMemo(() => renderMarkdown(content || ''), [content]);
  return <div className="hc-doc-body" dangerouslySetInnerHTML={{ __html: html }} />;
}
